import { defineStore } from 'pinia'

export const viewsStore = defineStore('views', {
  state: () => ({
    isRightCollapsed: false,
    isLeftCollapsed: false,
    flyViewState: 'MAP_VIEW',
    rightContainerWidth: 30,
    leftContainerWidth: 70,
    pixelsFromRight: 0,
    isAutomationShow: false,
    isDeviceSelectOpen: false,
    isModeSelectOpen: false,
    isAccountPanelOpened: false,
    isController: false,
    isConfirmModal: false,
    isSystemNotificationsOpen: false,
    isSettingsModal: false,
    isShowEStop: false,
    isLayerPanel: false,
    isDragging: false,
    preflightChecklistMode: null,
    isPreflightOpen: false,
    showLogPanel: false,
    showDeviceTakeoverModal: false,
    // AVSS PRS (Parachute Recovery System) state
    isAVSSPanelOpen: false,
    isAVSSStatusWindowOpen: false,
    isAVSSConfigOpen: false,
    isPOIExpanded: false,
    isMissionsExpanded: false,
    info: null as {
      title: string
      body: string
      action?: () => void
      actionText?: string
    } | null,
    infoTimeoutId: undefined as number | undefined,
    isMediaUploading: false,
    mediaUploadProgress: null as {
      uploadedCount: number
      expectedCount: number
      currentFileName: string
      flightId: string
    } | null,
  }),
  actions: {
    setProperty(prop: string, payload: any) {
      ;(this as any)[prop] = payload
    },
    showSingleElement(payload: string) {
      const views = [
        'isController',
        'isAutomationShow',
        'isDeviceSelectOpen',
        'isModeSelectOpen',
        'isSystemNotificationsOpen',
        'isAccountPanelOpened',
      ] as const
      views.forEach((view) => {
        if (view == payload) {
          ;(this as any)[view] = true
        } else {
          ;(this as any)[view] = false
        }
      })
    },
    resetViews() {
      const views = [
        'isAutomationShow',
        'isController',
        'isLayerPanel',
        'isDeviceSelectOpen',
        'isModeSelectOpen',
        'isAccountPanelOpened',
        'isSystemNotificationsOpen',
        'isPOIExpanded',
        'isMissionsExpanded',
      ] as const
      views.forEach((view) => {
        ;(this as any)[view] = false
      })
      this.info = null
      if (this.infoTimeoutId) {
        clearTimeout(this.infoTimeoutId)
        this.infoTimeoutId = undefined
      }
    },
    setInfo(
      title: string,
      body: string,
      timeout: number = 15000,
      actionText?: string,
      action?: () => void,
    ) {
      if (this.infoTimeoutId) clearTimeout(this.infoTimeoutId)
      this.info = { title, body, actionText: actionText || undefined, action: action || undefined }
      if (timeout) {
        this.infoTimeoutId = window.setTimeout(() => {
          this.info = null
          this.infoTimeoutId = undefined
        }, timeout)
      }
    },
    clearInfo() {
      this.info = null
      if (this.infoTimeoutId) {
        clearTimeout(this.infoTimeoutId)
        this.infoTimeoutId = undefined
      }
    },
  },
})
